const baseUrl = '//images2.r.pl/r-pl/';
const blogUrl = '/blog-nuxt/';
const markeryUrl = '/nuxt/map/';

export interface IRainbowImage {
  baseUrl?: string;
  url: string;
  alt: string;
  type?: string;
}

type TRainbowImageKeys =
  | 'samolotPrawy'
  | 'samolotLewy'
  | 'markerHotel'
  | 'markerAtrakcje'
  | 'markerSamolot'
  | 'markerwycieczka'
  | 'markerBiura'
  | 'markerCheck';

const rainbowImages: Record<TRainbowImageKeys, IRainbowImage> = {
  samolotPrawy: { url: `${baseUrl}${blogUrl}svg/samolot-prawy.svg`, alt: 'Zdjęcie samolotu' },
  samolotLewy: { url: `${baseUrl}${blogUrl}svg/samolot-lewy.svg`, alt: 'Zdjęcie samolotu' },
  markerHotel: {
    url: `${baseUrl}${markeryUrl}hotel.svg`,
    alt: 'Hotel',
    type: 'image/svg+xml',
    baseUrl,
  },
  markerAtrakcje: {
    url: `${baseUrl}${markeryUrl}atrakcje.svg`,
    alt: 'Atrakcje',
    type: 'image/svg+xml',
    baseUrl,
  },
  markerSamolot: {
    url: `${baseUrl}${markeryUrl}SAMOLOT.svg`,
    alt: 'Samolot',
    type: 'image/svg+xml',
    baseUrl,
  },
  markerwycieczka: {
    url: `${baseUrl}${markeryUrl}wycieczka-fakultatywna.svg`,
    alt: 'Wycieczka fakultatywna',
    type: 'image/svg+xml',
    baseUrl,
  },
  markerBiura: {
    url: `${baseUrl}${markeryUrl}biura.svg`,
    alt: 'Biuro',
    type: 'image/svg+xml',
    baseUrl,
  },
  markerCheck: {
    url: `${baseUrl}${markeryUrl}CHECK.svg`,
    alt: 'Check',
    type: 'image/svg+xml',
    baseUrl,
  },
};

export default rainbowImages;
